/**
 * Helper to open the global WhatsAppSendModal from any page.
 * Pages set the modal state locally and pass receiver + context.
 *
 * Phase 4b-2 — keeps the API surface tiny and consistent across modules.
 */

export const buildLeadVars = (lead) => ({
  name: lead?.name || lead?.contact_name || "",
  customer_name: lead?.name || lead?.contact_name || "",
  product: lead?.product_interest || "",
});

export const buildBillingVars = (doc) => ({
  name: doc?.customer_name || "",
  customer_name: doc?.customer_name || "",
  doc_number: doc?.number || doc?.doc_number || "",
  amount: typeof doc?.total === "number" ? `₹${doc.total.toLocaleString("en-IN")}` : "",
  expiry_date: (doc?.expiry_date || "").slice(0, 10),
});

export const buildPaymentVars = (pay) => ({
  name: pay?.customer_name || "",
  customer_name: pay?.customer_name || "",
  amount: typeof pay?.amount === "number" ? `₹${pay.amount.toLocaleString("en-IN")}` : "",
  doc_number: pay?.receipt_number || pay?.payment_id || "",
});

export const buildPOVars = (po) => ({
  name: po?.vendor_name || "",
  doc_number: po?.po_number || "",
  amount: typeof po?.total_amount === "number" ? `₹${po.total_amount.toLocaleString("en-IN")}` : "",
  delivery_location: po?.delivery_location || "",
  item_list: (po?.items || []).map(i => i.description || i.product_name || "").filter(Boolean).join(", "),
});

export const buildVendorVars = (v) => ({
  name: v?.contact_person || v?.name || "",
});

export const buildDCVars = (dc) => ({
  name: dc?.customer_name || "",
  customer_name: dc?.customer_name || "",
  doc_number: dc?.dc_number || "",
  dispatch_date: (dc?.dispatch_date || "").slice(0, 10),
  tracking_no: dc?.tracking_no || "",
});

export const buildAMCVars = (a) => ({
  name: a?.customer_name || "",
  doc_number: a?.amc_number || "",
  expiry_date: (a?.end_date || "").slice(0, 10),
  amount: typeof a?.amount === "number" ? `₹${a.amount.toLocaleString("en-IN")}` : "",
});

export const buildStaffVars = (u) => ({
  name: u?.name || "",
});
